import React from 'react';
import PropTypes from 'prop-types';

const YnfLogo = ({ name, fill, className, title }) => (
  <svg
    className={`${className}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="170.1px"
    height="170.1px"
    viewBox="0 0 170.1 170.1"
  >
    <title>{title || name}</title>
    <g>
      <path
        fill="none"
        className="ynf-logo-first"
        stroke={fill}
        strokeWidth={3}
        strokeMiterlimit={10}
        d="M8.4,65.6c0-1.1,0.9-2.4,1.9-2.8l72.1-28.1c1-0.4,2.8-0.4,3.8,0l73.5,28.1c1.1,0.4,1.9,1.7,1.9,2.8v39
		c0,1.1-0.9,2.4-1.9,2.8l-73.5,28.1c-1.1,0.4-2.8,0.4-3.8,0l-72.1-28.1c-1.1-0.4-1.9-1.7-1.9-2.8V65.6z"
      />
      <g>
        <path
          fill={fill}
          d="M39.1,100v-9.9c0-0.5,0.4-0.9,0.9-0.9h0c0,0,0,0,0,0h5.4c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H41v3.1
			h3.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H41v4c0,0.5-0.4,0.9-0.9,0.9C39.5,100.9,39.1,100.5,39.1,100z"
        />
        <path
          fill={fill}
          d="M60.1,99.5c0.2,0.5-0.1,1-0.6,1.2c-0.1,0-0.2,0-0.4,0c0,0,0,0,0,0c-0.2,0-0.4,0-0.7-0.2
			c-0.2-0.1-0.4-0.4-0.5-0.6c-0.2-0.5-0.4-1.1-0.4-2c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.4-0.5-0.5c-0.4-0.2-0.8-0.4-0.9-0.4h-2
			v3.6c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-9.9c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0,0h3c2,0,3.6,1.6,3.6,3.6
			c0,1.1-0.5,2.1-1.3,2.8c0.2,0.2,0.4,0.4,0.6,0.6c0.3,0.5,0.6,1.1,0.6,1.8c0,0.5,0,0.8,0.1,1C59.8,99,60,99.2,60.1,99.5z
			 M57.8,92.7c0-1-0.8-1.7-1.7-1.7H54v3.5h2.1C57,94.5,57.8,93.7,57.8,92.7z"
        />
        <path
          fill={fill}
          d="M66.4,90.1c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v9.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9
			V90.1z"
        />
        <path
          fill={fill}
          d="M75.5,100v-9.9c0-0.5,0.4-0.9,0.9-0.9h0c0,0,0,0,0,0h5.4c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9h-4.6
			v3.1h3.9c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9h-3.9V99h4.6c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9h-5.4c0,0,0,0,0,0
			l0,0C75.9,100.9,75.5,100.5,75.5,100z"
        />
        <path
          fill={fill}
          d="M90.8,99.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-9.8c0,0,0,0,0,0c0-0.3,0.1-0.6,0.4-0.8
			c0.4-0.3,1-0.2,1.3,0.2l5.4,7.5v-6.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v9.8c0,0.5-0.4,0.9-0.9,0.9
			c-0.3,0-0.5-0.1-0.7-0.3c0,0-0.1-0.1-0.1-0.1l-5.4-7.5V99.9z"
        />
        <path
          fill={fill}
          d="M104.5,100v-9.9c0-0.5,0.4-0.9,0.9-0.9h2c3.2,0,5.9,2.6,5.9,5.9c0,3.3-2.6,5.9-5.9,5.9h-2
			C104.9,100.9,104.5,100.5,104.5,100z M106.3,99h1c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4h-1V99z"
        />
        <path
          fill={fill}
          d="M118.2,98.1c0.3-0.4,0.9-0.4,1.2-0.1c0.7,0.6,2,1.3,3.2,1.3c0.8,0,1.6-0.3,2.1-0.6c0.5-0.4,0.7-0.8,0.7-1.2
			c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.3-0.3-0.5-0.5c-0.5-0.3-1.3-0.6-2.3-0.8h0c-0.8-0.2-1.5-0.4-2.2-0.7c-0.6-0.3-1.2-0.7-1.6-1.3
			c-0.3-0.4-0.4-0.9-0.4-1.4c0-1,0.6-1.9,1.3-2.5c0.8-0.6,1.8-0.9,2.9-0.9c1.6,0,2.8,0.8,3.7,1.3c0.4,0.3,0.5,0.8,0.2,1.2
			c-0.3,0.4-0.8,0.5-1.2,0.3c-0.9-0.6-1.7-1.1-2.7-1.1c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.3-0.6,0.7-0.6,1.1c0,0.2,0,0.3,0.1,0.5
			c0.1,0.1,0.2,0.3,0.5,0.4c0.4,0.3,1.2,0.6,2.1,0.7h0c0.9,0.2,1.6,0.4,2.3,0.7c0.7,0.3,1.3,0.8,1.7,1.4c0.3,0.4,0.4,0.9,0.4,1.4
			c0,1.1-0.6,2-1.4,2.6c-0.8,0.6-1.9,1-3.1,1c-1.8,0-3.3-0.9-4.3-1.7C117.9,99.1,117.9,98.5,118.2,98.1z"
        />
      </g>
      <g>
        <path
          fill={fill}
          d="M31.3,73.9l-3.4,4.7v4.5c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-4.5l-3.4-4.7c-0.3-0.4-0.2-1,0.2-1.3
			c0.4-0.3,1-0.2,1.3,0.2l2.9,3.9l2.9-3.9c0.3-0.4,0.9-0.5,1.3-0.2C31.5,72.9,31.6,73.5,31.3,73.9z"
        />
        <path
          fill={fill}
          d="M42.2,81.3h-4.1l-0.8,2.2c-0.2,0.4-0.5,0.6-0.9,0.6c-0.1,0-0.2,0-0.3-0.1c-0.5-0.2-0.7-0.7-0.6-1.2l3.7-9.9
			c0.2-0.4,0.5-0.6,0.9-0.6c0.4,0,0.7,0.2,0.9,0.6l3.7,9.9c0.2,0.5-0.1,1-0.6,1.2c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.7-0.2-0.9-0.6
			L42.2,81.3z M41.6,79.4l-1.4-3.6l-1.4,3.6H41.6z"
        />
        <path
          fill={fill}
          d="M49.6,78c0-3.3,2.8-6,6.2-6.1c1.5,0,2.8,0.5,3.9,1.3c0.4,0.3,0.5,0.9,0.2,1.3c-0.3,0.4-1,0.5-1.3,0.2
			c-0.7-0.6-1.7-0.9-2.7-0.9c-1.2,0-2.2,0.5-3,1.2c-0.8,0.8-1.2,1.8-1.2,2.9c0,1.1,0.5,2.2,1.2,2.9c0.8,0.7,1.9,1.2,3,1.2
			c1,0,1.9-0.3,2.7-0.9c0.4-0.3,1-0.2,1.3,0.2c0.3,0.4,0.2,1-0.2,1.3c-1.1,0.8-2.4,1.3-3.9,1.3C52.4,84.1,49.6,81.4,49.6,78z"
        />
        <path
          fill={fill}
          d="M66.4,83.1v-9.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v4h4.4v-4c0-0.5,0.4-0.9,0.9-0.9
			c0.5,0,0.9,0.4,0.9,0.9v9.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-4h-4.4v4c0,0.5-0.4,0.9-0.9,0.9
			C66.8,84.1,66.4,83.7,66.4,83.1z"
        />
        <path
          fill={fill}
          d="M87.8,74.2h-2.7v9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-9h-2.7c-0.5,0-0.9-0.4-0.9-0.9
			c0-0.5,0.4-0.9,0.9-0.9h7.2c0.5,0,0.9,0.4,0.9,0.9C88.7,73.7,88.3,74.2,87.8,74.2z"
        />
        <path
          fill={fill}
          d="M93.4,81.2c0.3-0.4,0.9-0.4,1.2-0.1c0.7,0.6,2,1.3,3.2,1.3c0.8,0,1.6-0.3,2.1-0.6c0.5-0.4,0.7-0.8,0.7-1.2
			c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.2-0.3-0.3-0.5-0.5c-0.5-0.3-1.3-0.6-2.3-0.8h0c-0.8-0.2-1.5-0.4-2.2-0.7c-0.6-0.3-1.2-0.7-1.6-1.3
			c-0.3-0.4-0.4-0.9-0.4-1.4c0-1,0.6-1.9,1.3-2.5c0.8-0.6,1.8-0.9,2.9-0.9c1.6,0,2.8,0.8,3.7,1.3c0.4,0.3,0.5,0.8,0.2,1.2
			c-0.3,0.4-0.8,0.5-1.2,0.3c-0.9-0.6-1.7-1.1-2.7-1.1c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.3-0.6,0.7-0.6,1.1c0,0.2,0,0.3,0.1,0.5
			c0.1,0.1,0.2,0.3,0.5,0.4c0.4,0.3,1.2,0.6,2.1,0.7h0c0.9,0.2,1.6,0.4,2.3,0.7c0.7,0.3,1.3,0.8,1.7,1.4c0.3,0.4,0.4,0.9,0.4,1.4
			c0,1.1-0.6,2-1.4,2.6c-0.8,0.6-1.9,1-3.1,1c-1.8,0-3.3-0.9-4.3-1.7C93.2,82.1,93.1,81.5,93.4,81.2z"
        />
      </g>
      <g>
        <path
          fill={fill}
          d="M114.4,85.4c-1.9,0-3.1-1.7-3.1-3.3l0,0c0-0.8,0.4-1.7,1.2-2.3l0,0c0.4-0.2,0.9-0.1,1.1,0.2l0,0
			c0.2,0.4,0.1,0.9-0.2,1.1l0,0c-0.3,0.2-0.5,0.5-0.5,0.9l0,0c0,0.4,0.2,0.8,0.4,1.1l0,0c0.3,0.3,0.6,0.5,1,0.5l0,0
			c0.4,0,0.9-0.2,1.6-0.8l0,0c1.5-1.4,5.5-6.3,8.3-9.5l0,0c1.1-1.2,1.9-2,2.6-2.5l0,0c0.7-0.5,1.2-0.8,1.8-0.8l0,0
			c0.2,0,0.5,0.1,0.8,0.3l0,0c0.3,0.2,0.4,0.5,0.4,0.8l0,0l0,0.1c-0.1,0.8-0.6,2.4-1.2,4.5l0,0c-0.6,2.1-1.3,4.5-1.8,6.2l0,0
			c-0.3,1.1-0.5,2.1-0.5,2.3l0,0c0,0.4-0.4,0.8-0.9,0.8l0,0c-0.4,0-0.8-0.4-0.8-0.9l0,0c0-0.5,0.3-1.4,0.6-2.6l0,0
			c0.3-1.2,0.8-2.6,1.2-4.1l0,0c0.6-2.1,1.3-4.2,1.6-5.4l0,0c-0.1,0-0.1,0.1-0.2,0.1l0,0c-0.6,0.4-1.3,1.1-2.3,2.3l0,0
			c-2.8,3.2-6.7,8-8.4,9.6l0,0C116.3,85,115.3,85.4,114.4,85.4L114.4,85.4C114.4,85.4,114.4,85.4,114.4,85.4L114.4,85.4z"
        />
        <path
          fill={fill}
          d="M136.7,77.7c-0.7-0.3-0.8-1-0.8-1.4l0,0c0-0.8,0.4-1.7,0.6-2.5l0,0c-0.3,0.2-0.6,0.5-0.9,0.7l0,0
			c-1.3,1.1-2.7,2.4-2.9,2.7l0,0c-0.2,0.3-0.6,0.4-1,0.3l0,0c-0.4-0.1-0.6-0.5-0.5-0.9l0,0c0.2-1,1.3-4.4,1.6-5.3l0,0h0
			c0.1-0.4,0.6-0.7,1-0.6l0,0c0.4,0.1,0.7,0.6,0.6,1l0,0c-0.1,0.4-0.4,1.4-0.7,2.4l0,0c0.1-0.1,0.3-0.2,0.4-0.3l0,0
			c1.1-1,2.3-2,2.9-2.4l0,0c0.2-0.1,0.2-0.2,0.4-0.3l0,0c0,0,0,0,0.2-0.1l0,0l0.3,0c0.3,0,0.6,0.2,0.7,0.5l0,0
			c0.1,0.2,0.1,0.4,0.1,0.6l0,0c0,0.7-0.4,1.4-0.7,2.3l0,0c-0.3,0.8-0.6,1.7-0.6,2l0,0c0,0,0,0,0,0l0,0c0.3,0.2,0.4,0.6,0.3,1l0,0
			c-0.1,0.3-0.4,0.5-0.7,0.5l0,0C136.9,77.8,136.8,77.7,136.7,77.7L136.7,77.7z M137.5,76.4L137.5,76.4
			C137.5,76.4,137.5,76.4,137.5,76.4L137.5,76.4z"
        />
        <path
          fill={fill}
          d="M140.3,77.2c-0.1-0.2-0.1-0.2-0.1-0.3l0,0c0-0.1,0-0.1,0-0.1l0,0c0-0.1,0-0.2,0.1-0.4l0,0c0,0,0,0,0,0l0,0
			c0-0.1,0-0.2,0.1-0.2l0,0c0.2-0.6,1.1-3.4,1.4-4.5l0,0v0c0.1-0.4,0.6-0.7,1-0.5l0,0c0.4,0.1,0.7,0.6,0.5,1l0,0
			c-0.3,1.1-1.2,3.9-1.4,4.5l0,0c0,0-0.1,0.2-0.1,0.4l0,0c0,0.1,0,0-0.2,0.3l0,0c-0.1,0.1-0.2,0.2-0.6,0.2l0,0c0,0,0,0,0,0l0,0
			C140.7,77.6,140.3,77.3,140.3,77.2L140.3,77.2z"
        />
        <path
          fill={fill}
          d="M141.1,77.6c-0.4,0-0.8-0.4-0.8-0.9l0,0c0-0.4,0.4-0.8,0.9-0.8l0,0c0.3,0,0.7,0,1,0l0,0
			c1.1,0,2.2-0.2,2.7-1.1l0,0c0.3-0.4,0.4-0.9,0.4-1.4l0,0c0-0.4-0.1-0.6-0.2-0.8l0,0c-0.1-0.2-0.8-0.4-1.7-0.3l0,0
			c-0.2,0-0.3,0-0.4,0l0,0c-0.3,0-0.6,0-0.9,0l0,0c-0.4-0.1-0.8-0.5-0.7-0.9l0,0c0.1-0.4,0.5-0.8,0.9-0.7l0,0c0.1,0,0.4,0,0.7,0l0,0
			c0.1,0,0.3,0,0.4,0l0,0c0.9,0,2.1-0.1,3,0.9l0,0c0.4,0.5,0.6,1.2,0.6,1.9l0,0c0,0.8-0.3,1.6-0.7,2.3l0,0c-1.1,1.6-2.8,1.8-4.1,1.8
			l0,0C141.8,77.7,141.4,77.6,141.1,77.6L141.1,77.6z"
        />
        <path
          fill={fill}
          d="M123.4,81.5c-0.4,0-0.8-0.4-0.8-0.8l0,0c0-0.4,0.4-0.8,0.8-0.8l0,0h22.3c0.4,0,0.8,0.4,0.8,0.8l0,0
			c0,0.4-0.4,0.8-0.8,0.8l0,0H123.4L123.4,81.5z"
        />
      </g>
    </g>
  </svg>
);

YnfLogo.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
  fill: PropTypes.string,
  className: PropTypes.string
};
YnfLogo.defaultProps = {
  fill: '#000000',
  className: ''
};
export default YnfLogo;